export function getAssigneeName(task, global) {
  if (!task?.assignee) {
    return 'Assignee'
  }
  if (task.assignee.user.id === global.user.id) return 'You'

  return `${task.assignee.user?.vaxiom_person?.first_name || 'Support'} ${task.assignee.user?.vaxiom_person?.last_name || ''}`
}
